import type { Comp } from "kaplay";
import type { Rider } from "../components/rider";
import { PX_PER_M } from "../config/constants";
import type { Surface } from "../config/types";
import { k } from "../core/kaplay";
import type { RunState } from "../core/runState";

interface TrackStyle {
    width: number;
    lifeS: number;
    opacity: number;
}

interface TrackPoint extends TrackStyle {
    pos: ReturnType<typeof k.vec2>;
    bornAt: number;
    joined: boolean;
}

const SPACING_PX = 0.4 * PX_PER_M;
const MAX_POINTS = 240;
const COLOR = k.rgb(60, 40, 25);

const STYLES: Partial<Record<Surface, TrackStyle>> = {
    mud: { width: 10, lifeS: 8, opacity: 0.6 },
    snow: { width: 6, lifeS: 6, opacity: 0.4 },
    dirt: { width: 4, lifeS: 4, opacity: 0.3 },
    grass: { width: 3, lifeS: 1.5, opacity: 0.12 },
    rock: { width: 2, lifeS: 1, opacity: 0.08 },
};
const DEFAULT_STYLE: TrackStyle = { width: 4, lifeS: 3, opacity: 0.25 };

function tyreTracks(rider: Rider, run: RunState): Comp {
    const points: TrackPoint[] = [];
    let onGround = false;

    return {
        id: "tyreTracks",
        update() {
            const now = k.time();
            while (points.length && now - points[0].bornAt > points[0].lifeS) points.shift();

            const grounded = rider.state === "riding" && rider.motion.speed > 0.5;
            const last = points[points.length - 1];
            if (grounded && (!last || last.pos.dist(rider.pos) >= SPACING_PX)) {
                points.push({ ...(STYLES[run.surface] ?? DEFAULT_STYLE), pos: rider.pos.clone(), bornAt: now, joined: onGround });
                if (points.length > MAX_POINTS) points.shift();
            }
            onGround = grounded;
        },
        draw() {
            const now = k.time();
            for (let i = 1; i < points.length; i++) {
                const p = points[i];
                if (!p.joined) continue;
                const fade = 1 - (now - p.bornAt) / p.lifeS;
                k.drawLine({ p1: points[i - 1].pos, p2: p.pos, width: p.width, color: COLOR, opacity: p.opacity * fade });
            }
        },
    };
}

export function addTyreTracks(rider: Rider, run: RunState) {
    return k.add([k.layer("ground"), k.z(2), tyreTracks(rider, run)]);
}
